var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Wrapper"}},[_c('Alert',{ref:"Alert",attrs:{"message":_vm.alertMessage,"subMessage":_vm.alertSubMessage,"errorFlag":_vm.errorFlag},on:{"confirmFinished":_vm.confirmFinished}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }